import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { getWrapperStyles } from './FieldWrapper.styles';

const FieldWrapper = ({
  children,
  columns = 1,
  disablePortal = false,
  customStyles,
  isHidden = false,
  ...props
}) => {
  if (isHidden) {
    return null;
  }

  return (
    <Box sx={getWrapperStyles({ columns, disablePortal, customStyles })} {...props}>
      {children}
    </Box>
  );
};

FieldWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  disablePortal: PropTypes.bool,
  customStyles: PropTypes.object,
  isHidden: PropTypes.bool,
};

export default FieldWrapper;
